export const MAX_IDS_PER_REQUEST = 150;

export const PERMISSIONS = {
  ADMIN: 'admin',

  // Cadastro
  LIST_DRIVERS: 'list-drivers',
  LIST_PROFILES: 'list-profiles',
  LIST_USERS: 'list-users',
  LIST_COST_CENTERS: 'list-cost-centers',
  LIST_AGGREGATED_DRIVES: 'list-aggregated-drivers',
  LIST_ATTENDANTS: 'list-station-attendants',
  LIST_CUSTOMERS: 'list-customers',
  LIST_MANAGERS: 'list-managers',
  LIST_NOTIFICATIONS: 'list-push-notifications',
  LIST_ROUTES: 'list-routes',
  LIST_CHATS: 'list-chats',
  LIST_VALETS: 'list-valets',
  LIST_VEHICLES: 'list-vehicles',
  LIST_VEHICLE_BASES: 'list-vehicle-bases',
  LIST_OPERATIONS: 'list-operations',
  LIST_VEHICLE_GROUPS: 'list-vehicle-groups',
  LIST_VOUCHERS: 'list-vouchers',
  EDIT_CONTRACTS: 'edit-contracts',
  CREATE_CONTRACTS: 'create-contracts',
  APPROVE_CONTRACTS: 'approve-contracts',
  MAILING_LIST: 'mailing-list',
  EDIT_STATIONS: 'edit-stations',
  EDIT_SUB_COMPANIES: 'edit-sub-companies',
  CREATE_INVOICE: 'create-invoice',
  CREATE_PROFILE: 'create-profile',
  UPDATE_PROFILE: 'update-profile',
  DELETE_PROFILE: 'delete-profile',
  DELETE_INVOICE: 'delete-invoice',
  FUEL_PRICE: 'fuel-price',
  LIST_SYSTEM_USER: 'list-system-user',
  CREATE_SYSTEM_USER: 'create-system-user',
  UPDATE_SYSTEM_USER: 'update-system-user',
  DELETE_SYSTEM_USER: 'delete-system-user',
  ADMIN_PROFILE: 'admin-profile',
  RATING_POLL_ITEMS: 'rating-poll-items',

  // Listagem
  LIST_FILLINS: 'list-fillins',
  LIST_STATIONS: 'list-stations',
  LIST_CONTRACTS: 'list-contracts',
  LIST_CHAINS: 'list-chains',
  LIST_RATNGS: 'list-ratings',
  LIST_COMPANIES: 'list-companies',
  LIST_FILLIN_ATTEMPTS: 'list-fillin-attempts',
  LIST_SUB_COMPANIES: 'list-sub-companies',
  EDIT_BILLS: 'edit-bills',
  LIST_INVOICE: 'list-invoice',
  LIST_SUB_COMPANY_BILLINGS: 'list-sub-company-billings',
  LIST_STATION_BILLINGS: 'list-station-billings',
  GENERATE_STATION_BILLING: 'generate-station-billing',
  GENERATE_SUBCOMPANY_BILLING: 'generate-subcompany-billing',
  APPROVE_FILLINS: 'approve-fillins',
  VIEW_APPROVED_FILLINS_BY: 'view-approved-fillins-by',

  // Contingência
  CREATE_FILLINS: 'create-fillins',
  LIST_OTP_CODES: 'opt-codes',
  FILL_IN_VEHICLE: 'fill-in-vehicle',

  // Configurações
  COMPANY_CONFIG: 'company-config',

  // Relatórios
  REPORT_FILLINS: 'report-fillins',
  REPORT_FINANCIAL: 'report-financial',
  REPORT_BLOCKED_DRIVERS: 'report-blocked-drivers',
  REPORT_TRANSACTIONS: 'report-transactions',
  REPORT_AVERAGE: 'report-average',
  REPORT_AVERAGE_BY_DRIVER: 'report-average-by-driver',
  REPORT_AVERAGE_BY_VEHICLE: 'report-average-by-vehicle',
  REPORT_INVOICES: 'report-invoices',
  REPORT_BILLS: 'report-bills',
  REPORT_PRICES: 'report-prices',
  REPORT_PRICE_CHANGES: 'report-price-changes',
  REPORT_VOUCHERS: 'report-vouchers',
  REPORT_DETAILED_PRICE: 'report-detailed-price',
  REPORT_BEST_PRICES: 'report-best-prices',
  REPORT_CONCILIATION: 'report-conciliation',
  REPORT_FILLIN_LICENSE: 'report-fillin-license',
  REPORT_BILLING_FORECAST_PAYMENT: 'report-billing-forecast-payment',
  REPORT_BILLING_FORECAST_RECEIVING: 'report-billing-forecast-receiving',
  REPORT_MARGIN: 'report-margin',

   // Permission to edit the global system default tax.
  EDIT_CHAIN_SYSTEM_DEFAULT_TAX: 'edit-chain-system-default-tax',

  // Permissions to edit the default network tax, divided by user level.
  EDIT_CHAIN_TAX_LEVEL_1: 'edit-chain-tax-level-1',
  EDIT_CHAIN_TAX_LEVEL_2: 'edit-chain-tax-level-2',
  EDIT_CHAIN_TAX_LEVEL_3: 'edit-chain-tax-level-3',

  // Permissions to edit special taxes, also divided by user level.
  EDIT_CHAIN_SPECIAL_TAX_LEVEL_1: 'edit-chain-special-tax-level-1',
  EDIT_CHAIN_SPECIAL_TAX_LEVEL_2: 'edit-chain-special-tax-level-2',
  EDIT_CHAIN_SPECIAL_TAX_LEVEL_3: 'edit-chain-special-tax-level-3',

  // Audit
  TAX_AUDIT_LOG: 'tax-audit-log',

};